import React, { useCallback, useEffect, useRef, useState } from "react";
import Loading from "../../../../loading/Loading";
import "./StandardTemplatesList.scss";
import { CommonEnums } from "../../../../../enums/common.enums";
import RightArrowIcon from "../../../../../components/icons/RightArrowIcon";
import LeftArrowIcon from "../../../../../components/icons/LeftArrowIcon";
import toast from "react-hot-toast";
import { TemplatesApi } from "../../../../../utils/api/Templates";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import { useSearchParams } from "react-router-dom";
import { getFontUrl } from "../../../../../utils/helpers/common";
import PreviewModal from "../../../workspace/propertypost/view/PreviewModal";
import { LocalStorageHelpers } from "../../../../../utils/helpers/localstorage.helpers";
import axiosInstance from "../../../../../utils/api/Axios";
import AgencyData from "../../../../../@types/agency.data";
// @ts-ignore
import DesignTemplateListCard from "./DesignTemplateListCard";

interface stateType {
  isLoading: boolean;
  listData: any[];
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  visibleCount: number;
  loadingMore: boolean;
  agencyData: AgencyData | null;
  brandData: any | null;
  useAgencyOfficeLogo: boolean;
  agencyFontsData: any;
  downloadingFontsData: boolean;
  loadingFontsData: boolean;
  fontsToBeLoaded: any[];
}

let initialAgencyFontsData = {
  title: {
    font_300: {
      postscript_name: "ArchivoExpanded-Light",
      loaded: false,
      error: false,
    },
    font_300_italic: {
      postscript_name: "ArchivoExpanded-LightItalic",
      loaded: false,
      error: false,
    },
    font_400: {
      postscript_name: "ArchivoExpanded-Regular",
      loaded: false,
      error: false,
    },
    font_400_italic: {
      postscript_name: "ArchivoExpanded-Italic",
      loaded: false,
      error: false,
    },
    font_500: {
      postscript_name: "ArchivoExpanded-Medium",
      loaded: false,
      error: false,
    },
    font_500_italic: {
      postscript_name: "ArchivoExpanded-MediumItalic",
      loaded: false,
      error: false,
    },
    font_600: {
      postscript_name: "ArchivoExpanded-SemiBold",
      loaded: false,
      error: false,
    },
    font_600_italic: {
      postscript_name: "ArchivoExpanded-SemiBoldItalic",
      loaded: false,
      error: false,
    },
    font_700: {
      postscript_name: "ArchivoExpanded-Bold",
      loaded: false,
      error: false,
    },
    font_700_italic: {
      postscript_name: "ArchivoExpanded-BoldItalic",
      loaded: false,
      error: false,
    },
    font_800: {
      postscript_name: "ArchivoExpanded-ExtraBold",
      loaded: false,
      error: false,
    },
    font_800_italic: {
      postscript_name: "ArchivoExpanded-ExtraBoldItalic",
      loaded: false,
      error: false,
    },
    font_900: {
      postscript_name: "ArchivoExpanded-Black",
      loaded: false,
      error: false,
    },
    font_900_italic: {
      postscript_name: "ArchivoExpanded-BlackItalic",
      loaded: false,
      error: false,
    },
  },
  subtitle: {
    font_300: {
      postscript_name: "ArchivoExpanded-Light",
      loaded: false,
      error: false,
    },
    font_300_italic: {
      postscript_name: "ArchivoExpanded-LightItalic",
      loaded: false,
      error: false,
    },
    font_400: {
      postscript_name: "ArchivoExpanded-Regular",
      loaded: false,
      error: false,
    },
    font_400_italic: {
      postscript_name: "ArchivoExpanded-Italic",
      loaded: false,
      error: false,
    },
    font_500: {
      postscript_name: "ArchivoExpanded-Medium",
      loaded: false,
      error: false,
    },
    font_500_italic: {
      postscript_name: "ArchivoExpanded-MediumItalic",
      loaded: false,
      error: false,
    },
    font_600: {
      postscript_name: "ArchivoExpanded-SemiBold",
      loaded: false,
      error: false,
    },
    font_600_italic: {
      postscript_name: "ArchivoExpanded-SemiBoldItalic",
      loaded: false,
      error: false,
    },
    font_700: {
      postscript_name: "ArchivoExpanded-Bold",
      loaded: false,
      error: false,
    },
    font_700_italic: {
      postscript_name: "ArchivoExpanded-BoldItalic",
      loaded: false,
      error: false,
    },
    font_800: {
      postscript_name: "ArchivoExpanded-ExtraBold",
      loaded: false,
      error: false,
    },
    font_800_italic: {
      postscript_name: "ArchivoExpanded-ExtraBoldItalic",
      loaded: false,
      error: false,
    },
    font_900: {
      postscript_name: "ArchivoExpanded-Black",
      loaded: false,
      error: false,
    },
    font_900_italic: {
      postscript_name: "ArchivoExpanded-BlackItalic",
      loaded: false,
      error: false,
    },
  },
  body: {
    font_300: {
      postscript_name: "ArchivoExpanded-Light",
      loaded: false,
      error: false,
    },
    font_300_italic: {
      postscript_name: "ArchivoExpanded-LightItalic",
      loaded: false,
      error: false,
    },
    font_400: {
      postscript_name: "ArchivoExpanded-Regular",
      loaded: false,
      error: false,
    },
    font_400_italic: {
      postscript_name: "ArchivoExpanded-Italic",
      loaded: false,
      error: false,
    },
    font_500: {
      postscript_name: "ArchivoExpanded-Medium",
      loaded: false,
      error: false,
    },
    font_500_italic: {
      postscript_name: "ArchivoExpanded-MediumItalic",
      loaded: false,
      error: false,
    },
    font_600: {
      postscript_name: "ArchivoExpanded-SemiBold",
      loaded: false,
      error: false,
    },
    font_600_italic: {
      postscript_name: "ArchivoExpanded-SemiBoldItalic",
      loaded: false,
      error: false,
    },
    font_700: {
      postscript_name: "ArchivoExpanded-Bold",
      loaded: false,
      error: false,
    },
    font_700_italic: {
      postscript_name: "ArchivoExpanded-BoldItalic",
      loaded: false,
      error: false,
    },
    font_800: {
      postscript_name: "ArchivoExpanded-ExtraBold",
      loaded: false,
      error: false,
    },
    font_800_italic: {
      postscript_name: "ArchivoExpanded-ExtraBoldItalic",
      loaded: false,
      error: false,
    },
    font_900: {
      postscript_name: "ArchivoExpanded-Black",
      loaded: false,
      error: false,
    },
    font_900_italic: {
      postscript_name: "ArchivoExpanded-BlackItalic",
      loaded: false,
      error: false,
    },
  },
};

const StandardTemplatesList = ({
  selectedId,
  postType,
  onSelectTemplate,
  selectedDesignTemplateStageSlug,
  dynamicStageLabel,
}: {
  selectedId: string;
  selectedAnnouncementSlug?: string;
  selectedDesignTemplateStageSlug?: string;
  postType: string;
  onSelectTemplate: (data: any) => void;
  dynamicStageLabel?: string;
}) => {
  const [state, setState] = useState<stateType>({
    isLoading: false,
    listData: [],
    totalPage: 1,
    totalCount: 0,
    pageNumber: 1,
    visibleCount: 6,
    loadingMore: false,
    agencyData: null,
    brandData: null,
    useAgencyOfficeLogo: false,
    agencyFontsData: initialAgencyFontsData,
    downloadingFontsData: true,
    loadingFontsData: true,
    fontsToBeLoaded: [],
  });

  const [rawApiData, setRawApiData] = useState<any[]>([]);
  const [localSelectedId, setLocalSelectedId] = useState<string>(
    selectedId || "",
  );
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImages, setPreviewImages] = useState<string[]>([]);

  const observer = useRef<IntersectionObserver | null>(null);
  const lazyReadyRef = useRef(false);

  useEffect(() => {
    lazyReadyRef.current = false;
    const t = setTimeout(() => {
      lazyReadyRef.current = true;
    }, 600);
    return () => clearTimeout(t);
  }, [state.listData]);

  const lastElementRef = useCallback(
    (node: HTMLDivElement | null) => {
      if (state.isLoading || state.loadingMore) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver(
        (entries) => {
          if (
            !entries[0]?.isIntersecting ||
            !lazyReadyRef.current ||
            state.loadingMore ||
            state.visibleCount >= state.listData.length
          )
            return;

          setState((prev) => ({ ...prev, loadingMore: true }));
          setTimeout(() => {
            setState((prev) => ({
              ...prev,
              visibleCount: Math.min(
                prev.visibleCount + 6,
                prev.listData.length,
              ),
              loadingMore: false,
            }));
          }, 500);
        },
        { root: null, rootMargin: "0px 0px -80px 0px", threshold: 0.1 },
      );
      if (node) observer.current.observe(node);
    },
    [
      state.isLoading,
      state.loadingMore,
      state.listData.length,
      state.visibleCount,
    ],
  );

  const getListApi = async (page: number) => {
    setState((prev) => ({ ...prev, isLoading: true }));
    const payload = { page, post_type: postType };
    const res = await TemplatesApi.getStandardTemplates(payload);
    if (res?.data?.success) {
      setRawApiData(res.data.data.docs);
      const totalDocs =
        res.data.data.totalDocs ??
        res.data.data.total ??
        res.data.data.totalPages * 12;
      setState((prev) => ({
        ...prev,
        isLoading: false,
        totalPage: res.data.data.totalPages,
        totalCount: totalDocs,
        visibleCount: 6,
        loadingMore: false,
      }));
    } else {
      setState((prev) => ({ ...prev, isLoading: false }));
      toast.error(res?.data?.message || "Error");
    }
  };

  useEffect(() => {
    getListApi(state.pageNumber);
  }, [state.pageNumber, postType]);

  useEffect(() => {
    setLocalSelectedId(selectedId);
  }, [selectedId]);

  // useEffect(() => {
  //   let agencyData = LocalStorageHelpers.getAgencyData() as any;

  //   const filteredFromDB = rawApiData.filter(
  //     (template: any) => String(template._id) !== String(selectedId),
  //   );

  //   const updatedList = filteredFromDB.map((template: any) => ({
  //     ...template,
  //     selected: String(template._id) === String(localSelectedId),
  //   }));

  //   setState((prev) => ({
  //     ...prev,
  //     listData: updatedList,
  //     agencyData,
  //     brandData: agencyData?.brand_id,
  //     useAgencyOfficeLogo: agencyData?.use_office_logo ?? false,
  //   }));
  // }, [rawApiData, localSelectedId, selectedId]);

  useEffect(() => {
    const agencyData = LocalStorageHelpers.getAgencyData() as any;

    const filteredFromDB = rawApiData.filter(
      (template: any) => String(template._id) !== String(selectedId),
    );

    setState((prev) => ({
      ...prev,
      listData: filteredFromDB.map((template: any) => ({
        ...template,
        selected: String(template._id) === String(localSelectedId),
      })),
      agencyData: prev.agencyData ?? agencyData,
      brandData: prev.brandData ?? agencyData?.brand_id,
      useAgencyOfficeLogo:
        prev.agencyData != null
          ? prev.useAgencyOfficeLogo
          : (agencyData?.use_office_logo ?? false),
    }));
  }, [rawApiData, selectedId]);

  useEffect(() => {
    setState((prev) => {
      if (!prev.listData.length) return prev;

      let changed = false;
      const newList = prev.listData.map((template) => {
        const shouldBeSelected =
          String(template._id) === String(localSelectedId);
        if (template.selected === shouldBeSelected) return template;
        changed = true;
        return { ...template, selected: shouldBeSelected };
      });

      if (!changed) return prev;
      return { ...prev, listData: newList };
    });
  }, [localSelectedId]);

  // --- FONT LOGIC ---
  const getFontKeys = (fonts: any, postscriptName: string) => {
    const matches = [];
    for (const textType in fonts) {
      for (const key in fonts[textType]) {
        if (fonts[textType][key].postscript_name === postscriptName) {
          matches.push({ text_type: textType, key });
        }
      }
    }
    return matches;
  };

  const preloadFonts = async ({ fontsToBeLoaded, agencyFontsData }: any) => {
    let updatedFontsData = { ...agencyFontsData };
    await Promise.all(
      fontsToBeLoaded.map(async (font: any) => {
        let fontKeys = getFontKeys(updatedFontsData, font.postscript_name);
        let fontUrl = getFontUrl(font);
        try {
          const fontFace = new FontFace(
            font.postscript_name,
            `url(${fontUrl})`,
          );
          await fontFace.load();
          document.fonts.add(fontFace);
          fontKeys.forEach(({ text_type, key }) => {
            updatedFontsData[text_type][key].loaded = true;
          });
        } catch (e) {
          console.error(e);
        }
      }),
    );
    setState((prev) => ({
      ...prev,
      loadingFontsData: false,
      downloadingFontsData: false,
      agencyFontsData: updatedFontsData,
    }));
  };

  const getFontVariants = async (type: string, mainFontId: string) => {
    const res = await axiosInstance.get(`/${type}/variants/for-main-font`, {
      params: { main_font_id: mainFontId },
    });
    return res.data?.data?.docs || [];
  };

  const fetchFontsData = async () => {
    setState((prev) => ({ ...prev, downloadingFontsData: true }));
    // FIX: Using 'as any' to bypass the 'settings' TS error
    const settings =
      state.brandData && !state.useAgencyOfficeLogo
        ? state.brandData.settings
        : (state.agencyData as any)?.settings;

    const fontTypes = [
      {
        id: settings?.title_fonts,
        from: settings?.title_fonts_selected_from,
        variant: "title",
      },
      {
        id: settings?.subtitle_fonts,
        from: settings?.subtitle_fonts_selected_from,
        variant: "subtitle",
      },
      {
        id: settings?.body_text_fonts,
        from: settings?.body_text_fonts_selected_from,
        variant: "body",
      },
    ];

    let allVariants: any[] = [];
    let designFontsData = { ...state.agencyFontsData };

    for (const item of fontTypes) {
      if (item.id && item.id !== "design_default") {
        const variants = await getFontVariants(item.from, item.id);
        variants.forEach((v: any) => {
          let fontKey = `font_${v.font_weight}${v.is_italic ? "_italic" : ""}`;
          if (designFontsData[item.variant]?.[fontKey]) {
            designFontsData[item.variant][fontKey] = {
              loaded: false,
              error: false,
              postscript_name: v.postscript_name,
              load_font: true,
            };
          }
          allVariants.push(v);
        });
      }
    }
    const uniqueFonts = Array.from(
      new Map(allVariants.map((v) => [v._id, v])).values(),
    );
    preloadFonts({
      agencyFontsData: designFontsData,
      fontsToBeLoaded: uniqueFonts,
    });
  };

  const fontsLoadedOnceRef = useRef(false);

  useEffect(() => {
    if (!state.agencyData) return;
    if (fontsLoadedOnceRef.current) return;
    fontsLoadedOnceRef.current = true;
    fetchFontsData();
  }, [state.agencyData, state.brandData]);

  // const onTemplateSelectInternal = (item: any) => {
  //   setLocalSelectedId(item._id);
  //   onSelectTemplate(item);
  //   setState((prev) => ({
  //     ...prev,
  //     listData: prev.listData.map((row) => ({
  //       ...row,
  //       selected: row._id === item._id,
  //     })),
  //   }));
  // };

  const onTemplateSelectInternal = useCallback(
    (item: any) => {
      setLocalSelectedId(item._id);
      onSelectTemplate(item);

      setState((prev) => ({
        ...prev,
        listData: prev.listData.map((row) => {
          const shouldBeSelected = String(row._id) === String(item._id);
          if (row.selected === shouldBeSelected) return row;
          return { ...row, selected: shouldBeSelected };
        }),
      }));
    },
    [onSelectTemplate],
  );

  const renderSkeletons = (count: number) => {
    return Array.from({ length: count }).map((_, index) => (
      <div className="skeleton-card" key={`skeleton-${index}`}>
        <div className="skeleton-image skeleton-shimmer"></div>
      </div>
    ));
  };

  if (state.downloadingFontsData || state.loadingFontsData || state.isLoading) {
    return (
      <div className="standard-templates-list-container">
        <div className="select-template-container">{renderSkeletons(6)}</div>
      </div>
    );
  }

  return (
    <div className="standard-templates-list-container">
      {state.listData.length === 0 ? (
        <div className="data-not-found">
          <p>Templates not found!</p>
        </div>
      ) : (
        <div className="select-template-container">
          {state.listData.slice(0, state.visibleCount).map((data) => {
            const DesignTemplateListCardWithStage =
              DesignTemplateListCard as React.ComponentType<any>;

            return (
              <DesignTemplateListCardWithStage
                key={data._id}
                designTemplateData={data}
                onTemplateSelect={onTemplateSelectInternal}
                agencyFontsData={state.agencyFontsData}
                skipConfirmModal={true}
                stageSlug={selectedDesignTemplateStageSlug}
                dynamicStageLabel={dynamicStageLabel}
              />
            );
          })}

          {state.loadingMore && renderSkeletons(6)}

          {state.visibleCount < state.listData.length && (
            <div
              ref={lastElementRef}
              className="lazy-load-trigger"
              style={{
                gridColumn: "1 / -1",
                height: "1px",
                margin: 0,
                padding: 0,
              }}
            ></div>
          )}
        </div>
      )}

      {state.totalPage > 1 && (
        <div className="template-list-pagination">
          <button
            className="preview-box pagination-button"
            onClick={() =>
              setState((p) => ({ ...p, pageNumber: p.pageNumber - 1 }))
            }
            disabled={state.pageNumber === 1}
          >
            <LeftArrowIcon />
          </button>
          <button
            className="next-box pagination-button"
            onClick={() =>
              setState((p) => ({ ...p, pageNumber: p.pageNumber + 1 }))
            }
            disabled={state.pageNumber === state.totalPage}
          >
            <RightArrowIcon />
          </button>
          <div className="pagination-page-no">
            <p>
              Viewing{" "}
              {state.listData.length > 0 ? (state.pageNumber - 1) * 12 + 1 : 0}–
              {(state.pageNumber - 1) * 12 + state.listData.length} of{" "}
              {state.totalCount || state.totalPage * 12} results
            </p>
          </div>
        </div>
      )}

      <PreviewModal
        open={previewOpen}
        onClose={() => setPreviewOpen(false)}
        images={previewImages}
      />
    </div>
  );
};

export default StandardTemplatesList;
